import './RunRouteExecutor.scss';
import React from 'react';
import { DocumentExecutionService } from '@services/actions/DocumentExecutionService';
import { ActionConfirmModal } from '@organisms/actions/ActionReason/ActionConfirmModal';
import { IRunRouteExecutorProps } from './IRunRouteExecutorProps';

export const RunRouteExecutorModal: React.FC<IRunRouteExecutorProps> = (props: IRunRouteExecutorProps) => (
    <ActionConfirmModal
        header={props.title}
        message={props.message}
        requireReason={props.requireReason}
        reasonLabel={props.reasonLabel}
        okButtonText={props.okButtonText}
        cancelButtonText={props.cancelButtonText}
        modalSize={props.modalSize}
        completeHandler={props.completeHandler}
        submit={(reason) => new DocumentExecutionService(props.docId).runRoute(props.actionKey, reason)}
    />
);
